var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import { attr, hasMany } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import { alias } from '@ember/object/computed';
let Recipe = (_dec = attr('number'), _dec2 = attr('number', {
  defaultValue: 1
}), _dec3 = hasMany('ingredient', {
  autosaved: ['itemVariation'],
  async: false
}), _dec4 = hasMany('item-variation', {
  async: false
}), _dec5 = alias('itemVariations.firstObject'), _dec6 = computed('ingredients'), _dec7 = computed('ingredientsAreLoaded', 'hasDirtyFields', 'ingredients.@each.isDirty'), _class = (_class2 = class Recipe extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "quantity", _descriptor, this);
    _initializerDefineProperty(this, "quantityDenominator", _descriptor2, this);
    // @ts-expect-error autosaved is a custom option we are using and not officially support by EmberData
    _initializerDefineProperty(this, "ingredients", _descriptor3, this);
    // Note: `itemVariation` is actually a 1:1 relationship, but the attribute representing the relationship
    // is on the variation, so this side is a "hasMany", although in practice there will only ever be 1 variation
    // per composition.
    _initializerDefineProperty(this, "itemVariations", _descriptor4, this);
    _initializerDefineProperty(this, "itemVariation", _descriptor5, this);
  }
  static catalogType() {
    return 'RECIPE';
  }
  get ingredientsAreLoaded() {
    return this.ingredients !== null;
  }
  get isDirty() {
    if (this.ingredientsAreLoaded && this.ingredients.any(o => o && o.isDirty)) {
      return true;
    }
    return super.isDirty;
  }
  rollbackRelationships() {
    if (this.ingredientsAreLoaded) {
      (this.ingredients || []).filter(o => !o.isNew).forEach(o => o.rollbackRelationships());
    }
    super.rollbackRelationships();
  }
  rollbackAttributes() {
    if (this.ingredientsAreLoaded) {
      (this.ingredients || []).filter(o => !o.isNew).forEach(o => o.rollbackAttributes());
    }
    super.rollbackAttributes();
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'recipe'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "quantity", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "quantityDenominator", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "ingredients", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "itemVariations", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "itemVariation", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "ingredientsAreLoaded", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "ingredientsAreLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), _class);
export { Recipe as default };